import PropTypes from 'prop-types';
import ButtonSwitcher from '../../../../../../../../common/Switcher';
import {useEffect} from 'react';

const PermanentSeasonalSwitcher = ({
	activeOptionKey,
	onActiveOptionChange,
	onMount,
}) => {
	useEffect(() => {
		if (onMount && typeof onMount === 'function') {
			onMount();
		}
	}, []);

	return (
		<ButtonSwitcher
			condensed
			icon="ri-hourglass"
			activeOptionKey={activeOptionKey}
			options={[
				{key: 'permanent', data: {nameDisplay: 'Permanent'}},
				{key: 'seasonal', data: {nameDisplay: 'Seasonal'}},
			]}
			onActiveOptionChange={onActiveOptionChange}
		/>
	);
};

PermanentSeasonalSwitcher.propTypes = {
	activeOptionKey: PropTypes.string,
	onActiveOptionChange: PropTypes.func,
	onMount: PropTypes.func,
};

export default PermanentSeasonalSwitcher;
